import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {ServiceStatusType} from "../../types/service-status.type";
import {CommonsService} from "../../../commons/services/commons-service.service";

export class ServiceStatusMultipleSelectListCtrl implements IController {
  statuses: ServiceStatusType[];
  options?: ServiceStatusType[];
  ngPlaceholder: any;
  onChange: Function;

  private selectedKeys: any;
  private queryString: any;
  public isSelectAll: boolean;

  constructor(private commonsService: CommonsService) {
  }

  $onInit() {
    if (!this.options?.length) {
      this.options = Object.values(ServiceStatusType);
    }
  }

  $onChanges(changes) {
    if (changes.statuses) {
      this.selectedKeys = [];
      _.forEach(this.statuses, (s) => {
        this.selectedKeys[s] = true;
      })
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onToggle(option, isSelected) {
    this.onChange({
      statuses: isSelected ? _.concat(this.statuses, [option]) :
        _.filter(this.statuses, (s) => {
          return s !== option;
        })
    });
  }


  submitQuery(query) {
    this.queryString = query;
  }

  onReset() {
    this.onChange({statuses: []});
  }

  onToggleSelectAll() {
    if (this.isSelectAll) {
      this.onReset();
    } else {
      this.onChange({statuses: this.options});
    }
  }

  isAllSelected() {
    this.isSelectAll = this.commonsService.checkIfArraysMatch(this.options, this.statuses);
    return this.isSelectAll;
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceStatusMultipleSelectList', {
    bindings: {
      statuses: '<',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./service-status-multiple-select-list.html').default,
    controller: ServiceStatusMultipleSelectListCtrl
  });
